// Redux store configuration
import { configureStore } from '@reduxjs/toolkit'
import gamificationReducer from './gamificationSlice'
import authReducer from './authSlice'

export const store = configureStore({
  reducer: {
    gamification: gamificationReducer,
    auth: authReducer
  }
})
